import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getTransferInput,
  getTransfersInput,
  TransferLiteModel,
  TransferModel,
} from './model';

export function useGetTransfers(
  input?: getTransfersInput,
  options?: UseQueryOptions<ExtendedApiResult<TransferLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<TransferLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getTransfers', input?.params],
      () =>
        QueryFetchFunction({
          url: 'transfers',
          params: input?.params,
        }),
      options,
    ),
    TransferLiteModel,
  );
}

export function useGetTransfer(
  input?: getTransferInput,
  options?: UseQueryOptions<ApiResult<TransferModel>, ApiError>,
): UseQueryResult<ApiResult<TransferModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getTransfer', input?.id],
      () =>
        QueryFetchFunction({
          url: `transfers/${input?.id}`,
        }),
      options,
    ),
    TransferModel,
  );
}

export function getTransfersKey(input?: getTransfersInput) {
  return ['getTransfers', input?.params];
}

export function getTransferKey(input?: getTransferInput) {
  return ['getTransfer', input?.id];
}
